export default function reduceData(originalData,maxDataCount=20){
  const data=[...originalData];
  const diffCountArray = [];

  for (let i = 0; i < data.length - 1; i++) {
    const diff = data[i + 1].x.min - data[i].x.max;
    const existingDiff = diffCountArray.find(item => item.diff === diff);
    if (existingDiff) {
      existingDiff.count++;
    } else {
      diffCountArray.push({ diff, count: 1 });
    }
  }
  diffCountArray.sort((a, b) => a.diff - b.diff);

  let limitCountIndex=diffCountArray.length-1;
  let totalCount=diffCountArray[0].count;
  for(let i=1;i<diffCountArray.length;i++){
    if(data.length-totalCount<=maxDataCount){
      limitCountIndex=i-1;
      break;
    }
    totalCount+=diffCountArray[i].count;
  }

  const newData = [];
  while (data.length > 0) {
    let combinedData = { x: { min: data[0].x.min, max: data[0].x.max }, y: data[0].y };
    let j = 1;
    while (j < data.length) {
      const diff = data[j].x.min - combinedData.x.max;
      if (diff <= diffCountArray[limitCountIndex].diff) {
        combinedData.x.max = data[j].x.max;
        combinedData.y += data[j].y;
        data.splice(j, 1);
      } else {
        break;
      }
    }
    newData.push(combinedData);
    data.shift();
  }


  return newData;
}